module.exports = __webpack_public_path__ + "img/list0.c78ad1de.png";